import * as Fetch from '@/helpers/fetch'

export const getPartnerOffers = async (token: string): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_MY_COUPON_SERVICE_URL}/v1/partner-offers`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
      channel: 'line',
      'Accept-Language': 'th'
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}